module.exports = __webpack_public_path__ + "static/media/locationMarker (1).a6e33be7.svg";